import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=61e85d61&"
import script from "./DeleteBtn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DeleteBtn.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e85d61')) {
      api.createRecord('61e85d61', component.options)
    } else {
      api.reload('61e85d61', component.options)
    }
    module.hot.accept("./DeleteBtn.vue?vue&type=template&id=61e85d61&", function () {
      api.rerender('61e85d61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/components/FilePreview/components/DeleteBtn.vue"
export default component.exports